import React from 'react'

import {
    Form,
    Input,
    Button,
    message,
    Divider,
} from 'antd';

import {
    CheckOutlined,
} from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

import { user } from "../../../../../service";

export default function UserAuthView() {
    const navigate = useNavigate()
        , [form] = Form.useForm()

    const onFinish = async () => {
        const value = await form.validateFields()
        try {
            const data = await user.apiAuth.userAuth(value)
            message.success(data.message)
            setTimeout(() => {
                navigate(-1)
            }, 1000);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            <div style={{ borderLeft: '5px solid #44AFAD', color: '#44AFAD', fontSize: '18px', paddingLeft: '5px' }}>
                <span>实名认证</span>
                <Button type='primary' onClick={() => navigate(-1)} style={{ float: 'right' }}>返回</Button>
            </div>

            <Divider />
            <Form
                form={form}
                layout='vertical'
                name='userauth.form'
                onFinish={onFinish}
                style={{ width: '360px', margin: '50px auto 0' }}
            >
                <Form.Item
                    name='idcard'
                    label='身份证号'
                    rules={[{ required: true, message: '请填写身份证' }]}
                >
                    <Input placeholder='请填写' />
                </Form.Item>

                <Form.Item
                    name='name'
                    label='真实姓名'
                    rules={[{ required: true, message: '请填写真实姓名' }]}
                >
                    <Input placeholder='请填写' />
                </Form.Item>

                <Form.Item>
                    <Button
                        icon={<CheckOutlined />}
                        type='primary'
                        block
                        size='large'
                        style={{ marginTop: '20px' }}
                        htmlType="submit"
                    >提 交</Button>
                </Form.Item>

            </Form>
        </>
    )
}
